import React from "react";
import { motion } from "framer-motion";
import { MapPin, Venus } from "lucide-react";
import { fadeUp, viewportOnce } from "../../lib/ui";

const AUD_IMG = "/himangini-audience.webp";

const SEGMENTS = ["Young Professionals", "Medical Students", "Junior Doctors"];

export const Demographics = () => {
  return (
    <section id="audience" data-testid="audience-section" className="px-4 py-20 sm:px-6 sm:py-28">
      <div className="mx-auto max-w-6xl">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mb-12 max-w-2xl"
        >
          <span className="font-body text-sm font-bold uppercase tracking-widest text-clay-violet">
            Who&apos;s watching
          </span>
          <h2 className="mt-3 font-display text-4xl font-black tracking-tighter text-clay-ink sm:text-6xl">
            An audience that trusts the recommendation.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-7 lg:grid-cols-12">
          {/* Big 85% stat */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="flex flex-col justify-between rounded-[2.25rem] border-[3px] border-clay-ink bg-clay-violet p-8 text-white shadow-clay lg:col-span-5"
          >
            <Venus className="h-9 w-9 text-clay-lime" strokeWidth={2.25} />
            <div className="mt-10">
              <p className="font-display text-[7rem] font-black leading-[0.8] tracking-tighter sm:text-[9rem]">
                85<span className="text-clay-lime">%</span>
              </p>
              <p className="mt-3 font-body text-lg font-bold uppercase tracking-wide">
                Female audience
              </p>
            </div>
          </motion.div>

          {/* Right column */}
          <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:col-span-7">
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewportOnce}
              className="overflow-hidden rounded-[2.25rem] border-[3px] border-clay-ink shadow-clay"
            >
              <img src={AUD_IMG} alt="Audience" className="h-48 w-full object-cover sm:h-full" />
            </motion.div>

            <motion.div
              custom={1}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewportOnce}
              className="flex flex-col justify-center rounded-[2.25rem] border-[3px] border-clay-ink bg-clay-lime p-7 shadow-clay"
            >
              <p className="font-display text-6xl font-black tracking-tighter text-clay-ink">
                18–28
              </p>
              <p className="mt-2 font-body text-sm font-bold uppercase tracking-wide text-clay-ink/80">
                Age range
              </p>
              <div className="mt-5 flex items-center gap-2 rounded-full border-2 border-clay-ink bg-white px-3 py-1.5 w-fit">
                <MapPin className="h-4 w-4 text-clay-violetdeep" strokeWidth={2.5} />
                <span className="font-body text-sm font-bold text-clay-ink">India</span>
              </div>
            </motion.div>

            <motion.div
              custom={2}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewportOnce}
              className="rounded-[2.25rem] border-[3px] border-clay-ink bg-clay-surface p-7 shadow-clay sm:col-span-2"
            >
              <p className="font-body text-sm font-bold uppercase tracking-widest text-clay-ink/60">
                Core segments
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                {SEGMENTS.map((s) => (
                  <span
                    key={s}
                    className="rounded-full border-[3px] border-clay-ink bg-white px-4 py-2 font-display text-sm font-bold text-clay-ink shadow-brutal-sm"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
